import { Action } from '@ngrx/store';
import { Menu } from './menu.state';
import { TreeNode } from 'src/app/core/tree/tree.interface';

export const SAVE	= '[Menu] Open Menu Item';
export const SELECT	= '[Menu] Select Menu Item';
export const DELETE = '[Menu] Delete Menu item';

export class Save implements Action {
	readonly type = SAVE;
	constructor(readonly payload: {menu:TreeNode[]}) { }
}


export class Select implements Action {
	readonly type = SELECT;
	constructor(readonly payload: {menu:TreeNode[]}) { }
}


export class Delete implements Action {
	readonly type = DELETE;
	constructor(readonly payload: {menu:TreeNode[]}) {
		payload.menu = []
	 }
}

export type Actions = Save | Select | Delete;
